import { addModals } from "@becon-team/becon-fe-lib/my-modal";

import { LanguageSelectModal } from "components/(modal)/LanguageSelectModal";
import { ScannerInfoB2CModal } from "components/(modal)/ScannerInfoB2CModal";
import { ScannerModeModal } from "components/(modal)/ScannerModeModal";
import { SkinInquiryModal } from "components/(skin)/(modal)/SkinInquiryModal";
import { CheckScannerModal } from "modules/bridge/components/CheckScannerModal";
import { PartnerCompanyContactModal } from "modules/partner/components/(modal)/PartnerCompanyContactModal";
import { PhoneVerificationModal } from "modules/phone/hooks/usePhoneVerification";
import { UserInquiryModal } from "modules/user/components/UserInquiryModal";
import { ScalpMeasureItemAppendixModal } from "pages/Scalp/components/AnalysisResult/(modal)/ScalpMeasureItemAppendixModal";

export const modalIds = {
  "skin-inquiry": "skin-inquiry",
  "language-select": "language-select",
  "scalp-measure-item-appendix": "scalp-measure-item-appendix",
  "user-inquiry": "user-inquiry",
  "scanner-info-b2c": "scanner-info-b2c",
  "scanner-mode": "scanner-mode",
  "phone-verification": "phone-verification",
  "partner-company-contact": "partner-company-contact",
  "check-scanner": "check-scanner",
} as const;

addModals([
  {
    id: modalIds["skin-inquiry"],
    component: () => <SkinInquiryModal />,
  },
  {
    id: modalIds["language-select"],
    component: () => <LanguageSelectModal />,
  },
  {
    id: modalIds["user-inquiry"],
    component: () => <UserInquiryModal />,
  },
  {
    id: modalIds["scanner-info-b2c"],
    component: () => <ScannerInfoB2CModal />,
  },
  {
    id: modalIds["scanner-mode"],
    component: () => <ScannerModeModal />,
  },
  {
    id: modalIds["scalp-measure-item-appendix"],
    component: () => <ScalpMeasureItemAppendixModal />,
  },
  {
    id: modalIds["phone-verification"],
    component: () => <PhoneVerificationModal />,
  },
  {
    id: modalIds["partner-company-contact"],
    component: () => <PartnerCompanyContactModal />,
  },
  {
    id: modalIds["check-scanner"],
    component: () => <CheckScannerModal />,
  },
]);
